<template>
  <button class="switcher" :class="`switcher--${ type }`" @click="$emit('click')">
    <span class="switcher__icon"/>
    <span class="switcher__text" v-html="switcherText"/>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
      validator: propValue => ['tile', 'map'].includes(propValue)
    }
  },
  computed: {
    switcherText () {
      return this.type === 'map' ? 'Układ kaflowy' : 'Widok Mapy'
    }
  }
}
</script>

<style lang="scss" scoped>
  .switcher {
    @include reset-button;
    @include hide-down(md);
    cursor: pointer;
    padding: 8px;

    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);

    z-index: z(switcher);

    transition: opacity $base-transition;

    @include media-up(xl) {
      bottom: 40px;
    }

    &:hover {
      opacity: .8;
    }

    &__icon {
      background-size: cover;
      display: inline-block;
      vertical-align: middle;

      width: 12px;
      height: 12px;
      margin-right: 16px;

      @include media-up(xl) {
        width: 19px;
        height: 19px;
        margin-right: 25px;
      }

      transition: transform .37s ease-in-out;
    }

    &:hover &__icon {
      transform: rotate(180deg);
    }

    &--map &__icon {
      background-image: url('/img/tiles-icon.svg');
    }

    &--tile &__icon {
      background-image: url('/img/map-icon.svg');
    }

    &__text {
      @include font($akrobat-font, 900);
      color: $base-opposite-color;

      text-transform: uppercase;
      letter-spacing: .3em;

      font-size: 12px;
      vertical-align: middle;

      position: relative;
      top: 2px;
      line-height: 1;

      @include media-up(xl) {
        font-size: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Map/Switcher.vue